import { render, staticRenderFns } from "./jiaoXue.vue?vue&type=template&id=0dd4a211&scoped=true"
import script from "./jiaoXue.vue?vue&type=script&lang=js"
export * from "./jiaoXue.vue?vue&type=script&lang=js"
import style0 from "./jiaoXue.vue?vue&type=style&index=0&id=0dd4a211&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4a211",
  null
  
)

export default component.exports